import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import RouterService from '@ember/routing/router-service';
import { Dropdown as BasicDropdown } from 'ember-basic-dropdown/components/basic-dropdown';
import ObjectTypeModel from 'cio/models/object-type';
import EnvironmentService from 'cio/services/environment';
import ObjectTypesService from 'cio/services/object-types';
import { safeQueryDecode } from 'cio/helpers/query';

export default class ObjectsTypeController extends Controller {
  @service router!: RouterService;
  @service environment!: EnvironmentService;
  @service('objectTypes') objectTypesService!: ObjectTypesService;

  @tracked isObjectFeedbackFormModalVisible = false;
  @tracked showRelationshipsModal = false;

  declare model: ObjectTypeModel;

  get showCommonHeader() {
    return [
      'objects.type.guide',
      'objects.type.list',
      'objects.type.loading', // so the header doesn't flicker on transition to "objects.type.list"
    ].includes(this.router.currentRouteName);
  }

  get showGuideTab() {
    return !this.model.hasNonUiObjects;
  }

  get filterConditions() {
    let filters = new URLSearchParams(window.location.search).get('filters');

    return safeQueryDecode(filters ?? '') as Record<string, unknown>[];
  }

  @action
  closeFeedbackDropdown(dropdown: BasicDropdown) {
    dropdown.actions.close();
  }

  @action
  toggleObjectFeedbackFormModal(show: boolean, dropdown?: BasicDropdown) {
    dropdown?.actions?.close?.();
    this.isObjectFeedbackFormModalVisible = show;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'objects.type': ObjectsTypeController;
  }
}
